// @ts-nocheck
const sounds = {
  incoming: '/sounds/message.mp3',
  request: '/sounds/notification.mp3',
  accepted: '/sounds/mention.mp3',
  report: '/sounds/admin.mp3',
};

export function playSound(key: keyof typeof sounds) {
  try {
    const audio = new Audio(sounds[key]);
    audio.volume = 0.6;
    audio.play();
  } catch {}
}


